import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Logo } from "@/components/brand/Logo";
import { LangSwitch } from "./Header";

const Col = ({ title, links }) => (
  <div>
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--gold)]">{title}</p>
    <ul className="mt-5 space-y-3">
      {links.map(([label, to, id, onClick]) => (
        <li key={id}>
          {onClick ? (
            <button onClick={onClick} data-testid={`footer-${id}`} className="text-sm text-[var(--steel)] hover:text-white transition-colors">{label}</button>
          ) : (
            <Link to={to} data-testid={`footer-${id}`} className="text-sm text-[var(--steel)] hover:text-white transition-colors">{label}</Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const { t } = useI18n();
  const f = t.footer;
  const openCookies = () => window.dispatchEvent(new Event("mb300:open-cookies"));
  return (
    <footer className="relative border-t border-white/10 bg-[var(--night)] pt-20 pb-10" data-testid="site-footer">
      <div className="container-x">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo />
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-[var(--gold)]" data-testid="footer-commercial-identity">by NELVIS FRANCE</p>
            <p className="font-display mt-6 text-3xl font-bold uppercase text-white">{f.tagline}</p>
            <LangSwitch className="mt-6" />
          </div>
          <div className="grid grid-cols-2 gap-10 lg:col-span-8">
            <Col title={f.product} links={[["MB300", "/#mb300", "mb300"], [t.catalog.nav.equipment, "/equipements", "equipment"], [t.catalog.nav.packs, "/packs", "packs"], [t.catalog.nav.deals, "/bonnes-affaires", "deals"], [t.nav.pricing, "/#tarifs", "pricing"], [t.nav.docs, "/documentation", "documentation"], [f.order, "/commander", "order"], [t.nav.faq, "/faq", "faq"], [t.nav.resellers, "/revendeurs", "resellers"], [t.nav.contact, "/contact", "contact"]]} />
            <Col title={f.legal} links={[[f.cgv, "/cgv", "cgv"], [f.mentions, "/mentions-legales", "mentions"], [f.privacy, "/confidentialite", "privacy"], [f.cookies, "/cookies", "cookies"], [t.cookies.manage, null, "manage-cookies", openCookies]]} />
          </div>
        </div>
        <div className="steel-line mt-16" />
        <div className="mt-8 flex flex-col gap-3 text-xs text-[var(--steel-dim)] md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} MB300 · by NELVIS FRANCE. {f.rights}</p>
          <p className="max-w-2xl md:text-right">{f.priceNote}</p>
        </div>
      </div>
    </footer>
  );
};
